import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

type UploadInput = { id: string; files: globalThis.File[] };

export function useUploadComunicadoMedia() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async ({ id, files }: UploadInput) => {
      const form = new globalThis.FormData();
      for (const f of files) form.append('media', f);
      return pb.send<{ id: string; media: string[] }>(
        `/api/comunicados/${id}/media`,
        { method: 'POST', body: form }
      );
    },
    onSuccess: (_d, v) => {
      qc.invalidateQueries({ queryKey: ['comunicado', v.id] });
    },
    onError: () => toast('Error al subir media', 'error'),
  });
}

export function useDeleteComunicadoMedia() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: { id: string; filename: string }) =>
      pb.send(`/api/comunicados/${v.id}/media/${v.filename}`, {
        method: 'DELETE',
      }),
    onSuccess: (_d, v) => {
      qc.invalidateQueries({ queryKey: ['comunicado', v.id] });
    },
    onError: () => toast('Error al eliminar media', 'error'),
  });
}
